/**
 * ToggleSwitch Component
 *
 * A reusable toggle switch component for boolean settings.
 *
 * @param {Object} props
 * @param {boolean} props.checked - Whether the toggle is on
 * @param {Function} props.onChange - Called when toggle state changes
 */

import React from "react";

const ToggleSwitch = ({ checked, onChange }) => {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only"
      />
      <div
        className={`w-8 h-4 rounded-full transition-colors ${
          checked ? "bg-blue-500" : "bg-gray-300 dark:bg-gray-600"
        }`}
      >
        <div
          className={`w-3 h-3 bg-white rounded-full shadow transition-transform ${
            checked ? "translate-x-[18px]" : "translate-x-[2px]"
          } mt-0.5`}
        ></div>
      </div>
    </label>
  );
};

export default ToggleSwitch;
